export const DEFAULT_REQUIREG_LOGIN = true;
export const DEFAULT_REQUIREG_USERDATA = true;
export const DEFAULT_AUTOLOGIN = false;

export const REDIRECT_INFO_KEY = '___crm___redirect_info';
